import { render, staticRenderFns } from "./ComboAdditionsKiosk.vue?vue&type=template&id=2e7e85bf&"
import script from "./ComboAdditionsKiosk.vue?vue&type=script&lang=js&"
export * from "./ComboAdditionsKiosk.vue?vue&type=script&lang=js&"
import style0 from "./ComboAdditionsKiosk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports